function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  opacity: 0.2,
  cx: 50,
  cy: 50,
  r: 50,
  fill: "#15A9E1"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2948_12167)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M71.1857 74.3098L71.1985 74.3227C68.3087 77.2125 64.3165 79 59.9071 79C52.1442 79 45.6769 73.4625 44.2384 66.122H44.2371C44.0414 65.1227 43.9384 64.0886 43.9384 63.0313C43.9384 54.2124 51.0869 47.0625 59.9071 47.0625V63.0313L71.1857 74.3098Z",
  fill: "#D0E2DF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M75.8758 63.0313H59.9071V47.0625C63.106 47.0625 66.0847 48.0026 68.583 49.6227C72.9718 52.4687 75.8758 57.4113 75.8758 63.0313Z",
  fill: "#B6CCE0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.9071 63.0312H75.8758C75.8758 67.4407 74.0884 71.4329 71.1985 74.3227L71.1857 74.3098L59.9071 63.0312Z",
  fill: "#005D81"
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.3853 43.6305H69.384H46.7534L30.7602 27.6373L30.7512 27.6296C34.8464 23.5331 40.5037 21 46.7547 21C59.2528 21 69.3853 31.1324 69.3853 43.6305Z",
  fill: "#005D81"
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.3839 43.6305H69.3852C69.3852 45.7052 69.1058 47.7142 68.5829 49.6227C66.0846 48.0026 63.1059 47.0625 59.907 47.0625C51.0868 47.0625 43.9383 54.2124 43.9383 63.0313C43.9383 64.0886 44.0413 65.1227 44.237 66.122C32.9224 64.8702 24.1241 55.2787 24.1241 43.6305C24.1241 37.3821 26.6573 31.7248 30.7512 27.6296L30.7602 27.6373L46.7534 43.6305H69.3839Z",
  fill: "#C1CDD3"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2948_12167"
}, /*#__PURE__*/React.createElement("rect", {
  width: 58,
  height: 58,
  fill: "white",
  transform: "translate(21 21)"
})));

var SvgInfographic = function SvgInfographic(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfographic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/infographic.9d6de123.svg";
export { ForwardRef as ReactComponent };